import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Classical_Antiquity_-_Maurya_and_Gupta_Empires_India.png';

function HistoryPageIndiaGo() {
  return (
    <QuizPage
      title="History: Maurya and Gupta Empires (India)"
      subTopic="Maurya and Gupta Empires (India)"
      backgroundImage={historyImage}
      returnPath="/History-Maurya-Gupta"
    />
  );
}

export default HistoryPageIndiaGo;   


